enum Breakpoints {
  TABLET_S = 'min-width: 640px',
  TABLET = 'min-width: 768px',
  LAPTOP = 'min-width: 1024px',
  LAPTOP_L = 'min-width: 1440px',
  DESKTOP_M = 'min-width: 1920px',
}

export default Breakpoints;
